import { saveConfig } from '@/vue-caas/views/processnew/component/saveConfig.js';

export async function runSave(vm, type, options = {}) {
  console.log(type);
  const flow = saveConfig[type];
  if (!flow) {
    return { success: false, message: `Unknown save type: ${type}` };
  }

  const mode = options.mode || 'form';
  const inputData = options.data;
  const ctxOptions = {
    mode,
    subType: options.subType,
  };
  console.log('Import Data:', inputData);

  // 1. VALIDATE
  const validateResult = await flow.validate(vm, inputData, ctxOptions);

  if (!validateResult?.ok) {
    return { success: false, message: validateResult?.message };
  }

  // 2. SAVE
  const saveCtx = (await flow.save(vm, inputData, ctxOptions)) || {};

  // 3. AFTER SAVE
  await flow.afterSave(vm, saveCtx, ctxOptions);

  return { success: true, ...saveCtx };
}
